import React from 'react';
import './Profile.css';
import profileImage from '../img/profile.jpg';

const Profile = () => {
  const expertise = [
    'エンジニア採用',
    'SES/受託営業',
    'キャリア支援',
    '組織設計',
    '医療SaaS',
    'グローバル人材'
  ];

  return (
    <section id="profile" className="profile section-light">
      <div className="container">
        <h2 className="profile__title animate-on-scroll">
          プロフィール
        </h2>

        <div className="profile__content">
          <div className="profile__image animate-on-scroll" style={{ animationDelay: '0.1s' }}>
            <img 
              src={profileImage} 
              alt="プロフィール" 
              className="profile__image-photo"
            />
          </div>

          <div className="profile__info animate-on-scroll" style={{ animationDelay: '0.2s' }}>
            <div className="profile__description">
              <p>
                ベンチャー企業にて、営業・採用・育成・組織設計を横断的に経験。
                エンジニア採用では年間50名以上の採用に貢献し、500件超の面談、キャリア支援実績を持つ。
              </p>
              <p>
                SES/受託開発の法人営業では、年間売上1.2億円を達成。<br />
                医療SaaSプロダクトの営業支援や、グローバル人材の<br />マネジメント経験も豊富。
              </p>
              <p>
                「コンサルではなく、経営者の“右腕”」をモットーに、<br />
                経営者が本来の業務に集中できる環境づくりを支援しています。
              </p>
            </div>

            <div className="profile__expertise">
              <h3>主な専門領域</h3>
              <div className="profile__tags">
                {expertise.map((tag, index) => (
                  <span key={index} className="profile__tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
